import { render } from "./TurnstileWidget.vue?vue&type=template&id=71c4bd06&scoped=true"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js"

import "./TurnstileWidget.vue?vue&type=style&index=0&id=71c4bd06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c4bd06"]])

export default __exports__